import { useState } from "react";
import { lookupCep } from "../../Services/cepService";
import { useTranslation } from "react-i18next";

export function useCepLookup({ onSuccess, onError } = {}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { t } = useTranslation();

    const lookup = async (cep) => {
        if (!cep || cep.trim() === "") {
            const errorMsg = t("client.form.error.zip_code.required");
            setError(errorMsg);
            onError?.(errorMsg);
            return;
        }

        // Verifica se o CEP tem o formato correto (8 dígitos)
        const cleanCep = cep.replace(/\D/g, "");
        if (cleanCep.length !== 8) {
            const errorMsg = t("client.form.error.zip_code.invalid");
            setError(errorMsg);
            onError?.(errorMsg);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const data = await lookupCep(cep);
            onSuccess?.(data);
        } catch (err) {
            let errorMessage = t("client.form.error.zip_code.message");

            if (err instanceof Error) {
                // Mapear erros específicos
                if (
                    err.message.includes("não encontrado") ||
                    err.message.includes("not found")
                ) {
                    errorMessage = t("client.form.error.zip_code.not_found");
                } else if (
                    err.message.includes("Timeout") ||
                    err.message.includes("timeout")
                ) {
                    errorMessage = t("client.form.error.zip_code.timeout");
                } else if (err.message.includes("8 dígitos")) {
                    errorMessage = t("client.form.error.zip_code.invalid");
                }
            }

            setError(errorMessage);
            onError?.(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const clearError = () => {
        setError(null);
    };

    return {
        lookup,
        loading,
        error,
        clearError,
    };
}
